PF.FileList.ImgItem = class ImgItem extends PF.FileList.Item
	{
	static get options()
		{
		return {};
		}

	get renderer()
		{
		//language=HTML
		return `
			<div class="img-file" pf="item" style="position: relative; margin-right: 8px; min-height:80px;">
				<img pf="img" src="" style="height:80px" alt=""/>
				<div class="select-box" pf="selectBox">
					<div class="select-circle" pf="selectCircle">
						<i class="select-check material-icons">done</i>
					</div>
				</div>
				<div class="preloader" pf="preloader" style="position: absolute; top: 20px; left:20px;">
					<span class="preloader-inner">
						<span class="preloader-inner-gap"></span>
						<span class="preloader-inner-left">
							<span class="preloader-inner-half-circle"></span>
						</span>
						<span class="preloader-inner-right">
							<span class="preloader-inner-half-circle"></span>
						</span>
					</span>
				</div>
			</div>
		`;
		}

	init()
		{
		super.init();
		this.photoBrowser = this.list.fileList.photoBrowser;
		}

	onRender(event)
		{
		super.onRender(event);

		this.calc('dom.img.attributes.src', 'model.file.filePreviews.img/h80.full_url');

		this.model.file.onValue('options.isUpload', true, () => {
			this.photoBrowser.params.photos.push({
				url: this.model.file.full_url,
				caption: this.model.file.name
			});
		});
		this.onChange('index', (oldValue, newValue) => {
			console.log(oldValue, newValue)
			this.photoBrowser.params.photos.splice(newValue, 1, {
				url: this.model.file.full_url,
				caption: this.model.file.name
			});
		});

		this.on('open', () => this.list.fileList.photoBrowser.open(this.index));
		this.useTrait(PF.FileList.ImgItem.Select, this.list.fileList.selectable);
		}

	delete(callDelete = true)
		{
		if (this.photoBrowser.swiper !== undefined)
			{
			this.photoBrowser.swiper.virtual.removeSlide(this.index);
			this.photoBrowser.swiper.virtual.update();
			this.photoBrowser.onSlideChange(this.photoBrowser.swiper);
			}
		else
			{
			this.photoBrowser.params.photos.splice(this.index, 1);
			}
		if (this.list.length === 0)
			{
			this.photoBrowser.close();
			}

		super.delete(callDelete);
		}
	};


PF.FileList.ImgItem.Select = class FileItemSelect extends PF.FileList.Item.Select
	{
	bindCheck()
		{
		this.bindDom({selectBox: 'show'}, 'list.fileList.selectMode');
		this.bindDom({selectCircle: 'class:selected'}, 'selectState');
		}
	};